import { makeAutoObservable } from 'mobx';
import {dateToJson} from 'shared/tools';
import {endpoints, types} from 'main/tools';
import {DomainStore} from 'shared/store';
import {TimeOffRequest} from 'main/stores/time_off';
import moment from 'moment';

class OutOfOfficeState {
  emojiReady;

  ptoRequests;
  selectedDate;
  loadingRequests = false;

  constructor() {
    makeAutoObservable(this, {
      emojiReady: false
    });
  }

  receiveProps({ptoRequests, emojiReady}) {
    this.ptoRequests = ptoRequests;
    this.emojiReady = emojiReady;
  }

  async load() {
    this.selectedDate = moment();
  }

  async selectDate(date) {
    this.selectedDate = moment(date);
    await this.fetchPtoRequestsForDate();
  }

  get formattedSelectedDate() {
    return this.selectedDate.format('DD-MM-YYYY');
  }

  async fetchPtoRequestsForDate() {
    if (!this.selectedDate.isValid()) return;

    this.loadingRequests = true;
    const store = new DomainStore();
    await store._compose([
      endpoints.TIME_OFF.PEOPLE_OFF.with(dateToJson(this.selectedDate.toDate()))
    ]);

    this.ptoRequests = store._getAll(types.TIME_OFF.REQUEST).map(request => new TimeOffRequest(request));
    this.loadingRequests = false;
  }
}

export default OutOfOfficeState;
